<script>
  import {
    branchesMethods,
  } from '@state/helpers'

  export default {
    props: {
      defaultFilters: {
        type: Array,
        default: () => [],
      },
      preloadData: {
        type: Array,
        default: () => [],
      },
      usePreload: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        departments: [],
        boundCollapse: true,
      }
    },
    computed:{
      departmentFilter(){
        return this.departments.map(el => {
          if (el.selected){
            return el.id
          }
        }).filter(el => el)
      }
    },
    watch: {
      departmentFilter (val) {
        this.$emit('filter', {
          department_ids: val,
        })
      },
    },
    async created() {
      // load options
      await this.loadDepartments()
    },
    methods: {
      ...branchesMethods,
      async loadDepartments () {
        if (this.usePreload){
          this.departments = this.preloadData
        }else{
          const {data} = await this.getListDepartments()
          const departments = data.data
          departments.forEach(el => el.selected = false)
          this.departments = departments
        }
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-department
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by department</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
        />
      </h3>
      <FabricBadge
        :styling-bg="departmentFilter.length ? 'badge-primary' : 'badge-light'"
        :copy="departmentFilter.length"
      />
    </div>
    <FabricCollapse
      id="accordion-department"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="boundCollapse">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll tw-overflow-x-hidden scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (departments && departments.length > 8) }">
        <FabricCheckbox
          v-for="department in departments"
          :key="department.id"
          v-model="department.selected"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ department.name }}</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
